export default {"src":"/_next/static/media/article-icon.3226e702.svg","height":19,"width":18};